module.exports = __webpack_public_path__ + "img/avatar_default.1b293f5c.png";